// Links shown in the panel come from app users (creator hub, pioneer, profile
// verification, milestones) or from staff. React 18 still runs a `javascript:`
// href when it is clicked, and the admin token lives in localStorage, so one
// such link could hand over an admin session. Every link built from data goes
// through safeUrl(): links that would run code are dropped (the anchor renders
// but is not clickable); everything else is returned unchanged.

const UNSAFE_SCHEME = /^(javascript|data|vbscript|file):/;

export const safeUrl = (value) => {
  if (value === null || value === undefined) return undefined;
  const url = String(value).trim();
  if (!url) return undefined;
  // Browsers ignore whitespace / control characters inside the scheme.
  // eslint-disable-next-line no-control-regex
  const compact = url.replace(/[\u0000- \u007f-\u009f]/g, "").toLowerCase();
  return UNSAFE_SCHEME.test(compact) ? undefined : url;
};

export default safeUrl;
